import React from 'react';
import {isNullOrUndefined} from "../../utils";


const DNSSECAccreditationIcon: React.FC<{color?: string, size?: string}> = (props) => {
    let iconColor = (!isNullOrUndefined(props.color) ? props.color : '#D50000');
    let iconSize =  (!isNullOrUndefined(props.size) ? props.size : '1.8rem');
    return (
        <div
            className="fa-layers fa-fw"
            style={{fontSize: iconSize, color: iconColor}}
        >
            <i className={'fas fa-lock'}/>
            <div
                className="fa-layers-text fa-inverse"
                data-fa-transform="shrink-8 down-3.5"
                style={{fontWeight: 800}}
            >
             .it
            </div>
        </div>
    );
};

export default DNSSECAccreditationIcon;